import { render, staticRenderFns } from "./trigger_config.vue?vue&type=template&id=1a9fce2f&scoped=true"
import script from "./trigger_config.vue?vue&type=script&lang=js"
export * from "./trigger_config.vue?vue&type=script&lang=js"
import style0 from "./trigger_config.vue?vue&type=style&index=0&id=1a9fce2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9fce2f",
  null
  
)

export default component.exports